import React from "react"
import EarningsTable from "./components/tables/EarningsTable";

export default class ReferralEarnings extends React.Component {

  constructor(props) {
    super(props)

    window.General.StatStatus = false

    this.state = {

    }
  }

  render() {
    return (
      <>
        <div className="g-5 gx-xxl-8">
          <div className="row gy-5 g-xl-8">
            <div className="col-xl-12">
              <EarningsTable
                title="Referral Earnings"
                subtitle="Users eligible for monthly referral payouts"
              />
            </div>
          </div>
        </div>
      </>
    )

  }

}
